import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type ActivatePendingAccountMutationVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type ActivatePendingAccountMutationResult = { __typename?: 'Mutation' } & {
  activatePendingAccount?: GraphQLTypes.Maybe<
    { __typename?: 'ActivatePendingAccountPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const ActivatePendingAccountDocument = /*#__PURE__*/ gql`
  mutation activatePendingAccount($accountId: String!) {
    activatePendingAccount(accountId: $accountId) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useActivatePendingAccountMutation__
 *
 * To run a mutation, you first call `useActivatePendingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePendingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePendingAccountMutation, { data, loading, error }] = useActivatePendingAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useActivatePendingAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<ActivatePendingAccountMutationResult, ActivatePendingAccountMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<ActivatePendingAccountMutationResult, ActivatePendingAccountMutationVariables>(
    ActivatePendingAccountDocument,
    options
  );
}
export type ActivatePendingAccountMutationHookResult = ReturnType<typeof useActivatePendingAccountMutation>;
